import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const show = window.setTimeout(() => setVisible(true), 5000);
    const hide = window.setTimeout(() => setVisible(false), 15000);
    return () => {
      window.clearTimeout(show);
      window.clearTimeout(hide);
    };
  }, []);
  return <AnimatePresence data-id="element-229" data-mp="21x25kbat0z3c">
      {visible && <motion.aside initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 14
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 right-4 z-50 w-[calc(100%-2rem)] max-w-sm rounded-lg border border-line border-l-4 border-l-field bg-white p-4 pr-10 text-ink shadow-lift" aria-live="polite" data-id="element-230" data-mp="21yvddtx5lpcx">
          <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded p-1 text-muted transition-colors duration-150 ease-out hover:text-ink focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" aria-label="Cerrar aviso" data-id="element-231" data-mp="hgfel1n43sjy">
            <XIcon className="h-4 w-4" data-id="element-232" data-mp="1jeg6kl20im7q" />
          </button>
          <div className="flex gap-3" data-id="element-233" data-mp="1ngjkrhg2g4wp">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-field" aria-hidden="true" data-id="element-234" data-mp="1nfi7r7fhp8cc" />
            <div data-id="element-235" data-mp="19omvdl5s8940">
              <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-earth" data-id="element-236" data-mp="19o3or0ll175a">Acceso confirmado</p>
              <p className="mt-1 text-sm leading-snug" data-id="element-237" data-mp="1ei7xnpeerp90">
                Al completar tu compra, recibís el<br data-id="element-238" data-mp="zt1wvwzx9qz0" />
                <span className="font-bold text-field" data-id="element-239" data-mp="14qbmpdr844nd">Megapack Yacimientos de Hidrocarburos Listo</span>
              </p>
              <p className="mt-2 text-xs text-muted" data-id="element-240" data-mp="qq0vuapwyq27">Acceso digital inmediato</p>
            </div>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}